




import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {IdMapper} from "../../../../../interfaces/state/base";
import {LadingCodePrintStatus, LadingCodeStatus} from "../../../../../enums/status";

@Component({
  name: "LadingCodePrintStatusLabel"
})
export default class extends mixins(CommonMixin) {
  @Prop({ required: true })
  readonly status!: number;

  LadingCodePrintStatus = LadingCodePrintStatus;
  colorMap: IdMapper<string> = {
    [LadingCodePrintStatus.NotPrint]: 'success',
    [LadingCodePrintStatus.Printed]: 'error'
  }
}
